export const categorizeURL = url => {
  const rootDomain = new URL(url).hostname.split('.').slice(-2).join('.')
  return domainCategories[rootDomain] || "Uncategorized"
}

export const domainCategories = {
  'careersinthemilitary.com': '_NA',
  'mccsmiramar.com': '_NA',
  'todaysmilitary.com': '_NA',
  'cgsuprt.com': '_NA',
  'flipsnack.com': '_NA',
  'academyadmissions.com': 'Air Force',
  'afrotc.com': 'Air Force',
  'afwm.org': 'Air Force',
  'airforce.com': 'Air Force',
  'af.mil': 'Air Force',
  'bellowsafs.com': 'Air Force',
  'myairforcelife.com': 'Air Force',
  'norad.mil': 'Air Force',
  'af.edu': 'Air Force',
  'jb.mil': 'Air Force',
  'afreserve.com': 'Air Force Reserve',
  'afciviliancareers.com': 'Air Force, Space Force',
  'spaceforce.mil': 'Air Force, Space Force',
  'spaceforce.com': 'Air Force, Space Force',
  'goang.com': 'Air National Guard',
  'goarmy.com': 'Army',
  'army.mil': 'Army',
  'ng.mil': 'Army',
  'armymwr.com': 'Army',
  'southcom.mil': 'Army',
  'nationalguard.mil': 'Army National Guard',
  'nationalguard.com': 'Army National Guard',
  'facebook.com': 'Army National Guard',
  'uscga.edu': 'Coast Guard',
  'gocoastguard.com': 'Coast Guard',
  'coastguardmwr.org': 'Coast Guard',
  'cybermission.tech': 'Cyber',
  'asvabprogram.com': 'Education',
  'citadel.edu': 'Education',
  'tamu.edu': 'Education',
  'marybaldwin.edu': 'Education',
  'norwich.edu': 'Education',
  'usma.edu': 'Education',
  'vmi.edu': 'Education',
  'vt.edu': 'Education',
  'officialasvab.com': 'Education',
  'usmc-mccs.org': 'Education',
  'usmma.edu': 'Education',
  'usuhs.edu': 'Education',
  'myfuture.com': 'Education',
  'acenet.edu': 'Education',
  'doded.mil': 'Education',
  'dantes.mil': 'Education',
  'maritime.edu': 'Education',
  'uscg.mil': 'Government',
  'defense.gov': 'Government',
  'militaryfamily.org': 'Government',
  'uscis.gov': 'Government',
  'disa.mil': 'Government',
  'va.gov': 'Government',
  'health.mil': 'Government',
  'mcas-gov.us': 'Government',
  'tricare.mil': 'Government',
  'house.gov': 'Government',
  'cac.mil': 'Government',
  'dol.gov': 'Government',
  'fvap.gov': 'Government',
  'sss.gov': 'Government',
  'tsp.gov': 'Government',
  'usa.gov': 'Government',
  'whitehouse.gov': 'Government',
  'marines.mil': 'Marine Corps',
  'usmc.mil': 'Marine Corps',
  'marineparents.com': 'Marine Corps',
  'mccsbarstow.com': 'Marine Corps',
  'marines.com': 'Marine Corps',
  'officercandidatesschool.com': 'Marine Corps',
  'navy.mil': 'Navy',
  'navy.com': 'Navy',
  'ning.com': 'Navy',
  'wallopsislandsurfacecombatsystemscenter.com': 'Navy',
  'globalsecurity.org': 'Navy',
  'navymwrsingapore.com': 'Navy',
  'navyschoolathens.com': 'Navy',
  'nps.edu': 'Navy',
  'usna.edu': 'Navy',
  'navymwr.org': 'Navy',
  'armymomstrong.com': 'Other',
  'militaryfriendly.com': 'Other',
  'whs.mil': 'Other',
  'jbsa.mil': 'Other',
  'militaryonesource.mil': 'Other',
  'redcross.org': 'Other',
  'toysfortots.org': 'Other',
  'armedforcesentertainment.com': 'Other',
  'usembassy.gov': 'Other',
  'kahoot.it': 'Other',
  'google.com': 'Other',
  'osd.mil': 'Other',
  'apple.com': 'Other',
  'amazonaws.com': 'Other',
  'twitter.com': 'Other',
  'bluestarmothers.org': 'Other',
  'dfas.mil': 'Other',
  'esgr.mil': 'Other',
  'gijobs.com': 'Other',
  'homes.mil': 'Other',
  'medicineandthemilitary.com': 'Other',
  'metc.mil': 'Other',
  'uso.org': 'Other',
  'ustranscom.mil': 'Other',
  'capmed.mil': 'Other',
  'yellowribbon.mil': 'Other',
  'youtube.com': 'Other',
}
